unit Essentials.Web.Attributes.Editor;

interface

uses
  System.SysUtils, System.Variants, System.Classes, Vcl.Graphics,
  Vcl.Controls, Vcl.Forms, Vcl.Dialogs, WebForm.Core, WEBLib.Lists,
  Vcl.StdCtrls, WEBLib.StdCtrls, WEBLib.Grids, WEBLib.DBCtrls, WEBLib.Controls,
  WEBLib.Dialogs, Data.DB, WEBLib.DB, Essentials.Web.BaseEditForm, Grid.Plugins,
  WEBLib.ExtCtrls, Web, WebLib.WebCtrls,   XData.Web.Connection,
  XData.Web.Client, Types, XData.Web.Dataset, JS;

type
  TEssentialsAttributeEditor = class(TCoreWebForm)
    AddButton: TButton;
    cbPageSize: TComboBox;
    ConfirmationMsg: TMessageDlg;
    EssentialsTable: TDBTableControl;
    lbPaginationInfo: TLabel;
    lcPaginator: TListControl;
    LoadButton: TButton;
    DataSource: TDataSource;
    SelectEntityComboBox: TLookupComboBox;
    procedure AddButtonClick(Sender: TObject);
    procedure LoadButtonClick(Sender: TObject);
    procedure cbPageSizeChange(Sender: TObject);
    procedure WebFormCreate(Sender: TObject);
    procedure EssentialsTableGetCellChildren(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string;
      AElement: TJSHTMLElementRecord);
    procedure DataSourceStateChange(Sender: TObject);
  private
    procedure AddRowActions(const ARecordId: string; AParentElement: TJSHTMLElement);
    const RECORD_ID_DELIMITER = ';';
  protected
    FIdField: string;
    FGridPlugin: TGridPlugin;
    [Async]
    procedure EditRecord(ARecordId: string); async;
    [Async]
    procedure ToggleActiveRecord(ARecordId: string); async;
    [Async]
    procedure LoadData; async;
    [Async]
    procedure LoadEntityList; async;
    [Async]
    procedure Save; async;
    procedure RefreshControls(aShow: Boolean);
    function GetJSArrayFromRecordIds(aRecordIds: string): TJSValueDynArray;
    function ConvertIdFieldsIntoRecords(aIdFields: string): string;
    procedure SetDataSet(aDataSet:TXdataWebDataset);
  public
    { Public declarations }
  protected procedure LoadDFMValues; override; end;

var
  EssentialsAttributeEditor: TEssentialsAttributeEditor;

implementation

uses Essentials.Web.Shared, SMX.Web.Layout.Utils, SMX.webcore.Types,
StrUtils, XData.Web.JsonDataset, Essentials.Web.Attributes.EditAttributeDefinitionForm,
Essentials.Shared;

{$R *.dfm}

procedure TEssentialsAttributeEditor.AddButtonClick(Sender: TObject);
begin
  inherited;
  EditRecord('');
end;

procedure TEssentialsAttributeEditor.RefreshControls(aShow: Boolean);
begin
  lcPaginator.Visible := aShow;
  lbPaginationInfo.Visible := aShow;
  cbPageSize.Visible := aShow;
end;


procedure TEssentialsAttributeEditor.Save;
begin
  EssentialsManager.AttributesManager.SaveAttributeDefinitionChanges;
end;

procedure TEssentialsAttributeEditor.SetDataSet(aDataSet: TXdataWebDataset);
begin
  DataSource.DataSet := aDataSet;
  AddButton.Enabled := DataSource.DataSet.Active;
end;

procedure TEssentialsAttributeEditor.AddRowActions(const ARecordId: string;
  AParentElement: TJSHTMLElement);
  procedure EditClick(Sender: TObject);
  begin
    EditRecord(ARecordId);
  end;

  procedure ToggleActiveClick(Sender: TObject);
  begin
    ToggleActiveRecord(ARecordId);
  end;

var
  Span: THTMLSpan;
  lIsActive: Boolean;
begin
  Span := TLayoutUtils.RowActionSpan(AParentElement, 'fad fa-edit', 'View');
  Span.OnClick := @EditClick;

  lIsActive := DataSource.DataSet.FieldByName('IsActive').AsBoolean;
  if lIsActive then
  begin
    Span := TLayoutUtils.RowActionSpan(AParentElement, 'fad fa-ban', 'Deactivate');
    Span.OnClick := @ToggleActiveClick;
  end
  else
  begin
    Span := TLayoutUtils.RowActionSpan(AParentElement, 'fad fa-check-circle', 'Reactivate');
    Span.OnClick := @ToggleActiveClick;
  end;
end;

procedure TEssentialsAttributeEditor.cbPageSizeChange(Sender: TObject);
begin
  inherited;
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text), True);
end;

function TEssentialsAttributeEditor.ConvertIdFieldsIntoRecords(aIdFields: string): string;
var
  idFieldsArr: TArray<string>;
  idField: string;
begin
    idFieldsArr := aIdFields.Split([RECORD_ID_DELIMITER]);
    Result := '';
    for idField in idFieldsArr do
      Result := IfThen(Result <> '', Result + RECORD_ID_DELIMITER, '') + DataSource.DataSet.FieldByName(idField).AsString;
end;

procedure TEssentialsAttributeEditor.DataSourceStateChange(Sender: TObject);
begin
  inherited;
  AddButton.Enabled := DataSource.DataSet.Active;
end;

procedure TEssentialsAttributeEditor.ToggleActiveRecord(ARecordId: string);
var
  foundRecord: Boolean;
  lIsActive: Boolean;
  lName, lMsg: string;
begin
  if ARecordId.Contains(RECORD_ID_DELIMITER) then
    foundRecord := DataSource.DataSet.Locate(FIdField, GetJSArrayFromRecordIds(ARecordId), [])
  else
    foundRecord := DataSource.Dataset.Locate(FIdField, ARecordId, []);

  if foundRecord then
  begin
    lIsActive := DataSource.DataSet.FieldByName('IsActive').AsBoolean;
    lName := DataSource.DataSet.FieldByName('Name').AsString;

    if lIsActive then
    begin
      ConfirmationMsg.Title := 'Deactivate';
      lMsg := Format('Are you sure you want to deactivate %s? It will no longer appear in dropdowns.', [QuotedStr(lName)]);
    end
    else
    begin
      ConfirmationMsg.Title := 'Reactivate';
      lMsg := Format('Are you sure you want to reactivate %s?', [QuotedStr(lName)]);
    end;

    if Await(TModalResult, ConfirmationMsg.ShowDialog(lMsg, mtConfirmation, [mbYes, mbNo])) = mrYes then
    begin
      DataSource.DataSet.Edit;
      DataSource.DataSet.FieldByName('IsActive').AsBoolean := not lIsActive;
      DataSource.DataSet.Post;
      Await(Save);
    end;
  end;
end;

procedure TEssentialsAttributeEditor.EditRecord(ARecordId: string);
var
  AForm: TEditAttributeDefinition;
  lNewName, lValueKind, lMsg: string;
  lMultiValue, lDeactivatedFound: Boolean;
begin
  AForm := TEditAttributeDefinition.Create(Self);
  try
    AForm.Popup := True;
    AForm.PopupOpacity := 1;
    Await(TEditAttributeDefinition, AForm.Load());
    AForm.SetDataSources(DataSource.DataSet);

    if ARecordId = '' then
    begin
      AForm.EditMode := Add;
      DataSource.DataSet.Insert;
    end
    else
    begin
      AForm.EditMode := None;
      DataSource.DataSet.Locate(FIdField, ARecordId, []);
    end;

    if Await(TModalResult, AForm.Execute) = mrOK then
    begin
      if ARecordId = '' then
      begin
        lNewName := DataSource.DataSet.FieldByName('Name').AsString;
        lValueKind := DataSource.DataSet.FieldByName('ValueKind').AsString;
        lMultiValue := DataSource.DataSet.FieldByName('MultiValue').AsBoolean;
        DataSource.DataSet.Cancel;

        lDeactivatedFound := False;
        DataSource.DataSet.First;
        while not DataSource.DataSet.Eof do
        begin
          if (not DataSource.DataSet.FieldByName('IsActive').AsBoolean) and
             SameText(DataSource.DataSet.FieldByName('Name').AsString, lNewName) then
          begin
            lDeactivatedFound := True;
            Break;
          end;
          DataSource.DataSet.Next;
        end;

        if lDeactivatedFound then
        begin
          lMsg := Format('A deactivated definition %s already exists. Would you like to reactivate it instead?', [QuotedStr(lNewName)]);
          ConfirmationMsg.Title := 'Reactivate Existing';
          if Await(TModalResult, ConfirmationMsg.ShowDialog(lMsg, mtConfirmation, [mbYes, mbNo])) = mrYes then
          begin
            DataSource.DataSet.Edit;
            DataSource.DataSet.FieldByName('IsActive').AsBoolean := True;
            DataSource.DataSet.Post;
            Await(Save);
          end;
        end
        else
        begin
          DataSource.DataSet.Insert;
          DataSource.DataSet.FieldByName('Name').AsString := lNewName;
          DataSource.DataSet.FieldByName('ValueKind').AsString := lValueKind;
          DataSource.DataSet.FieldByName('MultiValue').AsBoolean := lMultiValue;
          DataSource.DataSet.Post;
          Await(Save);
        end;
      end
      else
      begin
        DataSource.DataSet.Post;
        Await(Save);
      end;
    end;
  finally
    FreeAndNil(AForm);
  end;
end;

procedure TEssentialsAttributeEditor.EssentialsTableGetCellChildren(Sender: TObject;
  ACol, ARow: Integer; AField: TField; AValue: string;
  AElement: TJSHTMLElementRecord);
var
  RecordId: string;
begin
  if ARow = 0 then
    Exit;

  if EssentialsTable.Columns[ACol].Title = 'Actions' then
  begin
    RecordId := ConvertIdFieldsIntoRecords(FIdField);

    if RecordId <> '' then
      AddRowActions(RecordId, AElement.Element)
    else
      AElement.Element.textContent := 'Loading...';
  end;
end;


function TEssentialsAttributeEditor.GetJSArrayFromRecordIds(aRecordIds: string): TJSValueDynArray;
var
  recordIds: TArray<string>;
  i, arrLength: Integer;
begin
  recordIds := aRecordIds.Split([';']);
  arrLength := Length(recordIds);
  SetLength(Result, arrLength);

  for i := 0 to arrLength - 1 do
    Result[i] := recordIds[i];
end;

procedure TEssentialsAttributeEditor.LoadButtonClick(Sender: TObject);
begin
  inherited;
  LoadData;
end;

procedure TEssentialsAttributeEditor.LoadData;
var
  selectedEntity: string;
begin
  EssentialsManager.AttributesManager.AttributesDefinitionsDataset.Active := True;
  if not Assigned(FGridPlugin) then
  begin
    FGridPlugin := TGridPlugin.Create(EssentialsTable, EssentialsManager.AttributesManager.AttributesDefinitionsDataset, lcPaginator, lbPaginationInfo,
      TSortPair.Create(1, sdAsc));
    FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text));
  end;

  EssentialsManager.AttributesManager.SelectedEntity :=  SelectEntityComboBox.Value;
  EssentialsManager.AttributesManager.LocateAttributeDefinitions(selectedEntity);

  FGridPlugin.SetPreparedFilter(EssentialsManager.AttributesManager.GetFilter);
  RefreshControls(True);
end;


procedure TEssentialsAttributeEditor.LoadEntityList;
var
  lDef: TdtoLookupDef;
  lName, lCustom: string;
  lAssigned: Boolean;
  lSelectedEntity: string;
begin
  if EssentialsManager.AttributesManager.AttributesDefinitionsDataset.Active then
    lSelectedEntity := EssentialsManager.AttributesManager.AttributesDefinitionsDataset.FieldByName('EntityName').AsString;
  for lDef in EssentialsManager.AttributesManager.RegisteredEntities do
  begin
    lName := lDef.EntityClassName;
    lAssigned := Assigned(EssentialsManager.CustomNamesManager);
    if lAssigned then
       lCustom := EssentialsManager.CustomNamesManager.EntityCustomName(lName);

    SelectEntityComboBox.LookupValues.AddPair(lName, lCustom);

    if lSelectedEntity = lName then
      SelectEntityComboBox.ItemIndex := EssentialsManager.AttributesManager.RegisteredEntities.IndexOf(lDef);
  end;
end;

procedure TEssentialsAttributeEditor.WebFormCreate(Sender: TObject);
begin
  inherited;
  FIdField := 'Id';
  SetDataSet(EssentialsManager.AttributesManager.AttributesDefinitionsDataset);
  LoadEntityList;
  RefreshControls(False);
end;

procedure TEssentialsAttributeEditor.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lbPaginationInfo := TLabel.Create('essentials.attribute.PageInfo');
  AddButton := TButton.Create('essentials.attribute.add.button');
  cbPageSize := TComboBox.Create('essentials.attribute.PageSizeSelect');
  ConfirmationMsg := TMessageDlg.Create('ConfirmationMsg');
  EssentialsTable := TDBTableControl.Create('esssentials.attribute.table');
  lcPaginator := TListControl.Create('essentials.attribute.Pagination');
  LoadButton := TButton.Create('essentials.attribute.load.button');
  SelectEntityComboBox := TLookupComboBox.Create('essentials.attribute.entityselector');
  DataSource := TDataSource.Create(Self);

  lbPaginationInfo.BeforeLoadDFMValues;
  AddButton.BeforeLoadDFMValues;
  cbPageSize.BeforeLoadDFMValues;
  ConfirmationMsg.BeforeLoadDFMValues;
  EssentialsTable.BeforeLoadDFMValues;
  lcPaginator.BeforeLoadDFMValues;
  LoadButton.BeforeLoadDFMValues;
  SelectEntityComboBox.BeforeLoadDFMValues;
  DataSource.BeforeLoadDFMValues;
  try
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    lbPaginationInfo.SetParentComponent(Self);
    lbPaginationInfo.Name := 'lbPaginationInfo';
    lbPaginationInfo.Left := 185;
    lbPaginationInfo.Top := 32;
    lbPaginationInfo.Width := 112;
    lbPaginationInfo.Height := 15;
    lbPaginationInfo.Caption := 'No records to display';
    lbPaginationInfo.ElementFont := efCSS;
    lbPaginationInfo.ElementPosition := epIgnore;
    lbPaginationInfo.HeightStyle := ssAuto;
    lbPaginationInfo.HeightPercent := 100.000000000000000000;
    lbPaginationInfo.WidthStyle := ssAuto;
    lbPaginationInfo.WidthPercent := 100.000000000000000000;
    AddButton.SetParentComponent(Self);
    AddButton.Name := 'AddButton';
    AddButton.Left := 72;
    AddButton.Top := 296;
    AddButton.Width := 96;
    AddButton.Height := 25;
    AddButton.Caption := 'Add';
    AddButton.ChildOrder := 7;
    AddButton.ElementClassName := 'btn btn-light';
    AddButton.ElementFont := efCSS;
    AddButton.ElementPosition := epIgnore;
    AddButton.HeightStyle := ssAuto;
    AddButton.HeightPercent := 100.000000000000000000;
    AddButton.WidthStyle := ssAuto;
    AddButton.WidthPercent := 100.000000000000000000;
    SetEvent(AddButton, Self, 'OnClick', 'AddButtonClick');
    cbPageSize.SetParentComponent(Self);
    cbPageSize.Name := 'cbPageSize';
    cbPageSize.Left := 33;
    cbPageSize.Top := 29;
    cbPageSize.Width := 81;
    cbPageSize.Height := 23;
    cbPageSize.ElementClassName := 'form-select';
    cbPageSize.ElementFont := efCSS;
    cbPageSize.ElementPosition := epIgnore;
    cbPageSize.HeightStyle := ssAuto;
    cbPageSize.HeightPercent := 100.000000000000000000;
    cbPageSize.Text := '10';
    cbPageSize.WidthStyle := ssAuto;
    cbPageSize.WidthPercent := 100.000000000000000000;
    SetEvent(cbPageSize, Self, 'OnChange', 'cbPageSizeChange');
    cbPageSize.ItemIndex := 0;
    cbPageSize.Items.BeginUpdate;
    try
      cbPageSize.Items.Clear;
      cbPageSize.Items.Add('10');
      cbPageSize.Items.Add('25');
      cbPageSize.Items.Add('50');
      cbPageSize.Items.Add('100');
    finally
      cbPageSize.Items.EndUpdate;
    end;
    ConfirmationMsg.SetParentComponent(Self);
    ConfirmationMsg.Name := 'ConfirmationMsg';
    ConfirmationMsg.Left := 33;
    ConfirmationMsg.Top := 252;
    ConfirmationMsg.Width := 24;
    ConfirmationMsg.Height := 24;
    ConfirmationMsg.ElementClassName := 'PopUpForm';
    ConfirmationMsg.Buttons := [];
    ConfirmationMsg.Opacity := 0.200000000000000000;
    ConfirmationMsg.Title := 'Confirm';
    EssentialsTable.SetParentComponent(Self);
    EssentialsTable.Name := 'EssentialsTable';
    EssentialsTable.Left := 72;
    EssentialsTable.Top := 81;
    EssentialsTable.Width := 505;
    EssentialsTable.Height := 193;
    EssentialsTable.HeightStyle := ssAuto;
    EssentialsTable.WidthStyle := ssAuto;
    EssentialsTable.BorderColor := clSilver;
    EssentialsTable.ChildOrder := 3;
    EssentialsTable.ElementFont := efCSS;
    EssentialsTable.ElementHeaderClassName := 'thead-light';
    EssentialsTable.ElementPosition := epIgnore;
    EssentialsTable.ElementTableClassName := 'table table-striped table-bordered  table-hover';
    EssentialsTable.Footer.ButtonActiveElementClassName := 'btn btn-primary';
    EssentialsTable.Footer.ButtonElementClassName := 'btn btn-light';
    EssentialsTable.Footer.DropDownElementClassName := 'form-control';
    EssentialsTable.Footer.InputElementClassName := 'form-control';
    EssentialsTable.Footer.LinkActiveElementClassName := 'link-primary';
    EssentialsTable.Footer.LinkElementClassName := 'link-secondary';
    EssentialsTable.Footer.ListElementClassName := 'pagination';
    EssentialsTable.Footer.ListItemElementClassName := 'page-item';
    EssentialsTable.Footer.ListLinkElementClassName := 'page-link';
    EssentialsTable.Header.ButtonActiveElementClassName := 'btn btn-primary';
    EssentialsTable.Header.ButtonElementClassName := 'btn btn-light';
    EssentialsTable.Header.DropDownElementClassName := 'form-control';
    EssentialsTable.Header.InputElementClassName := 'form-control';
    EssentialsTable.Header.LinkActiveElementClassName := 'link-primary';
    EssentialsTable.Header.LinkElementClassName := 'link-secondary';
    EssentialsTable.Header.ListElementClassName := 'pagination';
    EssentialsTable.Header.ListItemElementClassName := 'page-item';
    EssentialsTable.Header.ListLinkElementClassName := 'page-link';
    SetEvent(EssentialsTable, Self, 'OnGetCellChildren', 'EssentialsTableGetCellChildren');
    EssentialsTable.Columns.Clear;
    with EssentialsTable.Columns.Add do
    begin
      DataField := 'Name';
      Title := 'Name';
    end;
    with EssentialsTable.Columns.Add do
    begin
      DataField := 'ValueKind';
      Title := 'ValueKind';
    end;
    with EssentialsTable.Columns.Add do
    begin
      DataField := 'MultiValue';
      DataType := cdCheck;
      Title := 'MultiValue';
    end;
    with EssentialsTable.Columns.Add do
    begin
      DataField := 'IsActive';
      DataType := cdCheck;
      Title := 'Active';
    end;
    with EssentialsTable.Columns.Add do
    begin
      Title := 'Actions';
    end;
    EssentialsTable.DataSource := DataSource;
    lcPaginator.SetParentComponent(Self);
    lcPaginator.Name := 'lcPaginator';
    lcPaginator.Left := 153;
    lcPaginator.Top := 354;
    lcPaginator.Width := 289;
    lcPaginator.Height := 25;
    lcPaginator.HeightStyle := ssAuto;
    lcPaginator.WidthStyle := ssAuto;
    lcPaginator.HeightPercent := 100.000000000000000000;
    lcPaginator.WidthPercent := 100.000000000000000000;
    lcPaginator.ChildOrder := 3;
    lcPaginator.DefaultItemClassName := 'page-item';
    lcPaginator.DefaultItemLinkClassName := 'page-link';
    lcPaginator.ElementFont := efCSS;
    lcPaginator.ElementPosition := epIgnore;
    lcPaginator.ElementListClassName := 'pagination';
    lcPaginator.Items.Clear;
    with lcPaginator.Items.Add do
    begin
      ItemClassName := 'page-item';
      LinkClassName := 'page-link';
      Text := 'Item 0';
    end;
    with lcPaginator.Items.Add do
    begin
      ItemClassName := 'page-item';
      LinkClassName := 'page-link';
      Text := 'Item 1';
    end;
    with lcPaginator.Items.Add do
    begin
      ItemClassName := 'page-item';
      LinkClassName := 'page-link';
      Text := 'Item 2';
    end;
    lcPaginator.Style := lsPagination;
    LoadButton.SetParentComponent(Self);
    LoadButton.Name := 'LoadButton';
    LoadButton.Left := 320;
    LoadButton.Top := 50;
    LoadButton.Width := 96;
    LoadButton.Height := 25;
    LoadButton.Caption := 'Load';
    LoadButton.ChildOrder := 2;
    LoadButton.ElementClassName := 'btn btn-light';
    LoadButton.ElementFont := efCSS;
    LoadButton.ElementPosition := epIgnore;
    LoadButton.HeightStyle := ssAuto;
    LoadButton.HeightPercent := 100.000000000000000000;
    LoadButton.WidthStyle := ssAuto;
    LoadButton.WidthPercent := 100.000000000000000000;
    SetEvent(LoadButton, Self, 'OnClick', 'LoadButtonClick');
    SelectEntityComboBox.SetParentComponent(Self);
    SelectEntityComboBox.Name := 'SelectEntityComboBox';
    SelectEntityComboBox.Left := 152;
    SelectEntityComboBox.Top := 53;
    SelectEntityComboBox.Width := 145;
    SelectEntityComboBox.Height := 22;
    SelectEntityComboBox.ElementClassName := 'form-select';
    SelectEntityComboBox.ElementFont := efCSS;
    SelectEntityComboBox.HeightPercent := 100.000000000000000000;
    SelectEntityComboBox.WidthPercent := 100.000000000000000000;
    SelectEntityComboBox.ItemIndex := -1;
    DataSource.SetParentComponent(Self);
    DataSource.Name := 'DataSource';
    SetEvent(DataSource, Self, 'OnStateChange', 'DataSourceStateChange');
    DataSource.Left := 528;
    DataSource.Top := 288;
  finally
    lbPaginationInfo.AfterLoadDFMValues;
    AddButton.AfterLoadDFMValues;
    cbPageSize.AfterLoadDFMValues;
    ConfirmationMsg.AfterLoadDFMValues;
    EssentialsTable.AfterLoadDFMValues;
    lcPaginator.AfterLoadDFMValues;
    LoadButton.AfterLoadDFMValues;
    SelectEntityComboBox.AfterLoadDFMValues;
    DataSource.AfterLoadDFMValues;
  end;
end;

end.
